export enum UserSubscriptionPaymentsType {
    Paid = 0,
    Complimentary = 1,
}
